import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../helpers/utility';

const initalState = {
    recentCalls: {},
    error: null,
    loading: false,
};

const callHistoryStart = (state, action) =>{ 
    return updateObject(state, {loading: true});
}

const callHistorySuccess = (state,action) =>{
    return updateObject(state, {
        recentCalls: action.recentCalls,
        loading: false,
        error: null,
    })
}

const callHistoryUpdate = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
};


const callHistoryFail = (state, action) => {
    return updateObject(state, {error: action.error, loading:false})
}

const reducer = (state = initalState, action) =>{
    switch(action.type){
      case  actionTypes.CALL_HISTORY_START:
    return callHistoryStart(state, action);
     case actionTypes.CALL_HISTORY_SUCCESS:
        return callHistorySuccess(state,action);
    case actionTypes.CALL_HISTORY_FAIL:
          return callHistoryFail(state,action); 
    case actionTypes.CALL_HISTORY_UPDATE:
         return callHistoryUpdate(state,action);
    default :
     return state;
    }
}

export default reducer;